const angular = require('angular');

const OfferGroupService = require('./offergroup.service');
const { offerGroupTileListComponentDefinition } = require('./offergroup-tile-list.component');

angular.module('wowApp.shop')
    .service('OfferGroupService', ['Restangular', '$q', 'Settings', 'SortByKeys', OfferGroupService])
    .component('wowOfferGroupTileList', offerGroupTileListComponentDefinition);



// WEBPACK FOOTER //
// ./src/shop/offergroup/index.js